<template>
  <section class="mt-2">
    <b-overlay :show="loading" rounded="sm">

      <b-form-group label-cols-md="3" :label="$t('STATE')">
        <b-form-select
          v-model="out_of_office_enabled"
          :options="outOfOfficeOptions"
        ></b-form-select>
      </b-form-group>

    <b-form-group
        label-cols-md="3"
        class="mb-2"
        :label="$t('MESSAGE')"
      >
        <b-form-textarea
          :disabled="!out_of_office_enabled"
          v-model="out_of_office_message"
          rows="5"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group>

      <b-button variant="primary" class="btn-fill" @click="saveSubmit">{{
        $t("SAVE")
      }}</b-button>
    </b-overlay>
  </section>
</template>
<script>
export default {
  props: ["userinfo"],
  data() {
    return {
      loading: false,
      out_of_office_enabled: this.userinfo.out_of_office_enabled,
      out_of_office_message: this.userinfo.out_of_office_message,
      outOfOfficeOptions: [
        { value: 0, text: this.$t("STATUS_INACTIVE") },
        { value: 1, text: this.$t("IM_OUT_OF_OFFICE") },
      ]
    };
  },
  methods: {
    saveSubmit: function() {
      let self = this;
      this.loading = true;
      this.$http
        .post(this.user.hostname + "/user/edit/out-of-office", {
          account_id: this.userinfo.id,
          out_of_office_enabled: this.out_of_office_enabled,
          out_of_office_message: this.out_of_office_message
        })
        .then(function() {
          self.$noty.info(self.$t("SAVED"));
          self.loading = false;
        })
        .catch(function() {
          self.loading = false;
          self.$noty.error(self.$t("ERROR.COULD_NOT_SAVE"));
        });
    }
  },
  computed: {
  },
  mounted: function() {},
};
</script>
<style></style>
